<div class="grid-col-12 customResponsiveFormlyElements">
    <sds-side-toolbar
    [responsiveSize]="1023"
    [responsiveButtonText]="'Advanced Search'"
    [responsiveDialogOptions]="responsiveDialogOptions"
    [showApply]="true"
    [dialogTitleText]="'Advanced Search'"
    [backButtonAria]="'Close Advanced Search'">
        <ng-template #toolbarContent>
            <div class="sds-card sds-card--collapsible">
                <div class="sds-card__header sds-card__header--action" role="button" aria-controls="filtersBody"
                    [attr.aria-label]="'Filter By'"
                    [attr.aria-expanded]="true">
                    <div class="sds-card__title">
                        Filter By
                    </div>
                </div>

                <div class="sds-card__body sds-card__body--accent-cool" id="filtersBody">
                    <sds-filters
                    [fields]="fields"
                    [model]="model"
                    [defaultModel]="{}"
                    (filterChange)="filterChange()">
                    </sds-filters>
                </div>
            </div>
        </ng-template>
    </sds-side-toolbar>
</div>